<template>
  <div class="meta-head">
    <div class="wrapper">
      <div class="title">
        {{ $ml.get(`Fields test`) }}
      </div>

      <app-btn @click="openModal">
        {{ $ml.get(`ADD TEST`) }}
      </app-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      load: true
    }
  },
  components: {
    
  },
  methods: {
    openModal() {
      this.$store.commit('tests/openCreateModal');
    }
  },
  computed: {

  }
}
</script>

<style lang="scss">

.meta-head {
  min-height: 80px;

  display: flex;
  flex-direction: row;
  align-items: center;

  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    height: 50px;
    padding-bottom: 10px;

    .title {
      color: #4C5056;
      font-size: 33px;
      line-height: 100%;
      font-weight: bold;
    }
  }
}

</style>